module.exports = __webpack_public_path__ + "img/max_kyc_desktop.db785cfe.png";